import { createContext, useContext } from 'react';
import { Member, Project, Role } from '../types';

export enum MODAL_NAMES {
  REMOVE_FROM_PROJECT = 'REMOVE_FROM_PROJECT',
  ADD_TO_PROJECT = 'ADD_TO_PROJECT',
  MEMBERSHIP_ROLE = 'MEMBERSHIP_ROLE',
  RESET_MFA = 'RESET_MFA',
  RESET_PASSWORD = 'RESET_PASSWORD',
  REVOKE_ACCESS = 'REVOKE_ACCESS',
  BULK_REVOKE_ACCESS = 'BULK_REVOKE_ACCESS',
  NEW_MEMBER = 'NEW_MEMBER',
  UPDATE_MEMBER = 'UPDATE_MEMBER',
}

export type MemberPayload = {
  member: Member;
};

export type MembersPayload = {
  members: Member[];
};

export type MemberProjectPayload = {
  member: Member;
  project: Project;
};

export type MemberRolePayload = {
  member: Member;
  project: Project;
  role: Role;
};

export type ModalState = {
  name: MODAL_NAMES;
  payload?: MemberPayload | MembersPayload | MemberProjectPayload | MemberRolePayload | null;
};

export type ModalContextState = {
  showModal: (modalState: ModalState) => void;
  hideModal: () => void;
  modalState: ModalState | null;
};

const defaultState = {
  showModal: () => null,
  hideModal: () => null,
  modalState: null,
};

export const OrganizationModalsContext = createContext<ModalContextState>(defaultState);

export const useOrganizationModalsContext = () => useContext(OrganizationModalsContext);
